class Alert {
    static generalAlertTimeout = null;
    static showGeneralAlert(message) {
        let $alert = jQuery('.general-alert');
        if(jQuery('.stories-wrapper.open').length > 0) {
            $alert = jQuery('.stories-general-alert')
        }
        $alert.find('.message').text(message);
        if($alert.hasClass('show')) {
            clearTimeout(Alert.generalAlertTimeout);
        } else {
            $alert.addClass('show');
        }
        Alert.generalAlertTimeout = setTimeout(function () {
            $alert.removeClass('show');
        }, 5300);
        return false;
    }
}

export default Alert;